import React from 'react';
import { useWaitlist } from '../context/WaitlistContext';

const CTASection = () => {
  const { openModal } = useWaitlist();

  return (
    <section className="section-marg cta-section">
      <h2 className="section-title cta-title">Made for humans, not machines</h2>
      <p className="section-subtitle cta-subtitle">In a time where the AI tsunami is sweeping through nearly every creative industry, Fiktion offers writers a space to dream, think and write, without surrendering to the wave of artificial shortcuts.</p>
      <div className="cta-buttons">
      <a href="https://app.fiktion.io/signup" target="_blank" rel="noopener noreferrer"><button className="btn btn-large btn-primary">Start writing</button></a>
      </div>
    </section>
  );
};

export default CTASection;

